<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Pirates</h3>
      </div>
      <form @submit.prevent>
        <div class="form-group text-left">
          <label for="locationFound">Location</label>
          <base-input class="mb-3"
                      id="locationFound"
                      required='required'
                      placeholder=""
                      name='locationFound'
                      v-model="pirates.locationFound"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('locationFound')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="companyName">Company Name</label>
          <base-input class="mb-3"
                      id="companyName"
                      required='required'
                      placeholder=""
                      name='companyName'
                      v-model="pirates.companyName"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('companyName')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="qty">Qty</label>
          <base-input class="mb-3"
                      id="qty"
                      required='required'
                      placeholder=""
                      name='qty'
                      v-model="pirates.qty"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('qty')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="brochureName">Brochure Name</label>
          <base-input class="mb-3"
                      id="brochureName"
                      required='required'
                      placeholder=""
                      name='brochureName'
                      v-model="pirates.brochureName"
                      type="text"
                      addonRightIcon=''
                      :error="vErrors.first('brochureName')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="">Pirate Picture (Front)</label>
          <div>
            <a v-on:click='takePicture(["pirates", "pictureFront"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{pirates.pictureFront.length}}</badge>
            <div v-if="showErrorPictureFront"><span class="errorimagesquantity">Front picture is required</span></div>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="">Pirate Picture (Back)</label>
          <div class="mb-3">
            <a v-on:click='takePicture(["pirates", "pictureBack"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{pirates.pictureBack.length}}</badge>
            <div v-if="showErrorPictureBack"><span class="errorimagesquantity">Back picture is required</span></div>
          </div>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="pirates.notFromCtmLocation">
            Did not come from a CTM location
          </base-checkbox>
        </div>
        <div class="text-center">
          <base-button :disabled="disableButton" type="primary" @click="piratesSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import timestampMixinMixin from './../views/mixins/timestampMixin'
import alertMixin from './../views/mixins/alertMixin'
import camera from './Camera'
import ax
  from "@/http-common";
import {
  validators
} from "vue-form-generator";
export default {
  data () {
    return {
      showCamera: null,
      disableButton: null,
      showErrorPictureFront: false,
      showErrorPictureBack: false,
      pirates: {
        pictureFront: [],
        pictureBack: [],
        locationFound: null,
        companyName: null,
        brochureName: null,
        notFromCtmLocation: false,
        qty: null
      }
    }
  },
  mounted () {
    this.setLocationFound()
  },
  methods: {
    setLocationFound () {
      if (this.$route.params.customJob) {
        this.pirates.locationFound = this.$route.params.location
        return
      }

      let currentJobInfo = this.$store.state.driverJobs.find(job => {
        return job.id === this.$store.state.currentJob ? job : null
      })
      if (currentJobInfo) {
        this.pirates.locationFound = '' + currentJobInfo.locationId
      }
    },
    resetForm () {
      this.pirates.pictureFront = []
      this.pirates.pictureBack = []
      this.pirates.companyName = null
      this.pirates.brochureName = null
      this.pirates.qty = null

      if (!confirm('Anymore pirates?')) {
        this.$router.push({ path: this.$route.params.fromForms ? '/forms' : (this.$route.params.customJob ? '/jobs' : '/job/' + this.$store.state.currentJob) })
      }
    },
    piratesSend () {
      this.showErrorPictureFront = !this.pirates.pictureFront.length
      this.showErrorPictureBack = !this.pirates.pictureBack.length
      if (this.showErrorPictureBack || this.showErrorPictureFront) {
        return
      }
      this.$validator.validateAll({
        locationFound: this.pirates.locationFound,
        companyName: this.pirates.companyName,
        qty: this.pirates.qty
      }).then(result => {
        if (result) {
          this.piratesSubmit(this.pirates)
        }
      })
    },
    combaineImages (imagesArray) {
      let combainedArr = []
      imagesArray.forEach(imageObj => {
        let images = imageObj.images
        images.forEach(image => {
          let combainedImageObj = {
            photoType: imageObj.photoType,
            signature: imageObj.signature,
            image: image
          }
          combainedArr.push(combainedImageObj)
        })
      })
      return combainedArr
    },
    async piratesSubmit (data) {
      this.disableButton = true
      let frontPictures = await this.getImagesFromIndexedDb(data.pictureFront)
      let backPictures = await this.getImagesFromIndexedDb(data.pictureBack)
      let piratesData = {
        LocationFound: data.locationFound,
        Company_Name: data.companyName,
        Qty_Found: data.qty,
        Brochure_Name: data.brochureName,
        Not_From_CTM_Location: data.notFromCtmLocation
      }

      let piratesFrontImages = {
        formType: 'pirates',
        images: frontPictures,
        photoType: false,
        signature: false
      }
      let piratesBackImages = {
        formType: 'pirates',
        photoType: true,
        images: backPictures,
        signature: false
      }
      let serverData = {
        token: this.$store.state.user.token,
        formType: 'pirates',
        records: JSON.stringify(piratesData),
        images: this.combaineImages([piratesFrontImages, piratesBackImages]),
        time: this.getCurrentTime()
      }
      this.showPreloader = true
      this.$store.dispatch('sendPiratesRequest', serverData)
        .then(response => {
          if (response) {
            this.showPreloader = false
            this.disableButton = false
            this.showAlert(3, 'Current job action is finished successfully')
            this.resetForm()
          }
        })
        .catch(err => {
          this.showPreloader = false
          this.disableButton = false
          if (this.isOffline) {
            this.showAlert(3, 'You are offline now. The data has been save and upload when online')
            this.resetForm()
          }
          if (!this.errorStatusAvaible(err) && this.isOnline) {
            this.resetForm()
            return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          }
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
        })
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, timestampMixinMixin, alertMixin, jobsMixin, standsMixin],
  components: {
    camera
  }
}
</script>
